/* UTF-8 admin tab: it-support */
import React from 'react'

export function renderItSupport(ctx) {
  const {
    activeTab,
    handleItReply,
    itActiveWorker,
    itConversations,
    itEndRef,
    itMessages,
    itReply,
    setItActiveWorker,
    setItMessages,
    setItReply,
  } = ctx
  return (
    <>
          {activeTab === 'it-support' && (
            <div className="dash-section">
              <div className="dash-section-header"><h2>🛠️ IT Support Center</h2><p>Respond to worker IT support requests in real time.</p></div>
              <div className="dash-it-layout">
                {/* Conversation list */}
                <div className="dash-it-list">
                  {itConversations.length === 0 ? (
                    <div className="dash-empty-state"><span>💬</span><p>No support requests yet.</p></div>
                  ) : (
                    itConversations.map(conv => (
                      <div
                        key={conv.workerId}
                        className={`dash-it-conv-item ${itActiveWorker === conv.workerId ? 'active' : ''}`}
                        onClick={() => { setItActiveWorker(conv.workerId); setItMessages(conv.messages) }}
                      >
                        <div className="dash-it-conv-avatar">{conv.workerName?.[0]?.toUpperCase() || '?'}</div>
                        <div className="dash-it-conv-info">
                          <span className="dash-it-conv-name">{conv.workerName}</span>
                          <span className="dash-it-conv-last">{conv.messages.at(-1)?.text?.slice(0, 40) || ''}…</span>
                        </div>
                        <span className="dash-it-conv-count">{conv.messages.filter(m => m.sender === 'worker').length}</span>
                      </div>
                    ))
                  )}
                </div>
                {/* Chat panel */}
                <div className="dash-it-chat-panel">
                  {!itActiveWorker ? (
                    <div className="dash-empty-state" style={{ flex: 1 }}><span>👈</span><p>Select a conversation to reply.</p></div>
                  ) : (
                    <>
                      <div className="dash-it-chat-header">
                        <strong>{itConversations.find(c => c.workerId === itActiveWorker)?.workerName}</strong>
                        <span style={{ fontSize: '0.8rem', color: '#6b7280' }}>Worker ID: {itActiveWorker}</span>
                      </div>
                      <div className="dash-it-messages">
                        {itMessages.map(m => (
                          <div key={m.id} className={`dash-it-msg ${m.sender}`}>
                            <span className="dash-it-msg-name">{m.sender === 'worker' ? m.workerName : (m.agentName || 'IT Team')}</span>
                            <p className="dash-it-msg-text">{m.text}</p>
                            <span className="dash-it-msg-time">{new Date(m.timestamp).toLocaleString()}</span>
                          </div>
                        ))}
                        <div ref={itEndRef} />
                      </div>
                      <form className="dash-it-reply-form" onSubmit={handleItReply}>
                        <input className="dash-chat-input" value={itReply} onChange={e => setItReply(e.target.value)} placeholder="Type your reply…" />
                        <button className="dash-btn primary" type="submit">Reply</button>
                      </form>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* ── CHAT ─────────────────────────────────────────── */}
    </>
  )
}
